<script setup>
import { ref } from 'vue';
import { fetchAsset } from '../loadData';

const privacyPolicy = ref('Loading...');

(async function getAsset() {
  try {
    privacyPolicy.value = await fetchAsset('../legal/privacy.partial.html');
    console.log(privacyPolicy.value.slice(0,15) === '<!DOCTYPE html>'
      ? '⚠️ incorrectly fetched the index page'
      : '✅ fetch succeeded');
  } catch (error) {
    console.error('❌ Failed to load privacy policy:', error);
    privacyPolicy.value = 'Failed to load privacy policy.';
  }
})();
</script>

<template>
  <div>
    <div v-html="privacyPolicy"></div>
  </div>
</template>

<style lang="scss">

</style>
